import React from "react"
import { makeStyles } from "@material-ui/core/styles"

import LinearProgress from "@material-ui/core/LinearProgress"

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
}))

export default function ViewLoadSpinner() {
  const classes = useStyles()
  return <LinearProgress className={classes.root} />
}
